import { render } from "./eventTag.vue?vue&type=template&id=73d61cf1"
import script from "./eventTag.vue?vue&type=script&lang=js"
export * from "./eventTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__